import { HubConnectionBuilder, LogLevel } from '@microsoft/signalr'
import { baseUrls } from './const'
import ApiService from '@/services/ApiService.js'
import store from './store/store'

export default {
  install(Vue) {
    // use a new Vue instance as the interface for Vue components to receive/send SignalR events
    // this way every component can listen to events or send new events using this.$hub
    const hub = new Vue()
    Vue.prototype.$hub = hub

    // Provide methods to connect/disconnect from the SignalR hub
    let connection = null
    let startedPromise = null
    let manuallyClosed = false
    let maxRetryTimes = 5
    let retryTimes = 0

    Vue.prototype.startSignalR = () => {
      connection = new HubConnectionBuilder()
        .withUrl(baseUrls.signalRUrl)
        .configureLogging(LogLevel.Trace)
        .build()

      // Forward hub events through the event, so we can listen for them in the Vue components
      connection.on('podDataReceived', data => {
        broadMessage(data, 'pod-data-received')
      })

      // You need to call connection.start() to establish the connection but the client wont handle reconnecting for you!
      // Docs recommend listening onclose and handling it there.
      // This is the simplest of the strategies
      function start() {
        retryTimes++
        return connection
          .start()
          .then(() => {
            retryTimes = 0
            localStorage.setItem('connection', JSON.stringify(connection))
            addToGroup()
            return Promise.resolve('connected')
          })
          .catch(err => {
            if (retryTimes < maxRetryTimes) {
              return new Promise((resolve, reject) =>
                setTimeout(() => {
                  start()
                    .then(resolve)
                    .catch(reject)
                }, 5000)
              )
            } else {
              return Promise.reject(err)
            }
          })
      }

      connection.onclose(() => {
        if (!manuallyClosed) start()
      })

      // Start everything
      manuallyClosed = false
      startedPromise = start()
      return startedPromise
    }
    Vue.prototype.stopSignalR = () => {
      if (!startedPromise) return

      manuallyClosed = true
      return startedPromise
        .then(() => connection.stop())
        .then(() => {
          startedPromise = null
        })
    }

    Vue.prototype.addToGroup = (pod = null) => {
      return addToGroup(pod)
    }

    function addToGroup(pod = null, retryCount = 0) {
      return new Promise((resolve, reject) => {
        if (!connection.connectionId) {
          if (retryCount >= 5)
            return reject(new Error('Failed to obtain the connection ID'))

          setTimeout(() => {
            addToGroup(pod, retryCount + 1)
          }, 2000)
          return
        }

        const podId = pod || store.state.pods.selectedPod.podId
        if (!podId) return reject(new Error('Missing podId'))

        const params = {
          ConnectionId: connection.connectionId,
          UserName: 'pod_' + podId
        }

        ApiService.AddToGroup(params)
          .then(response => {
            if (response.status >= 200 && response.status <= 299) {
              resolve(response)
            } else {
              reject(
                new Error(
                  'Failed to join group, status code ' + response.status
                )
              )
            }
          })
          .catch(err => {
            reject(err)
          })
      })
    }

    // Intercept patients only belonging to this filter
    function broadMessage(patient, event) {
      hub.$emit(event, JSON.parse(JSON.stringify(patient)))
    }
  }
}
